export default __webpack_public_path__ + "static/media/passport 1.df26ef30.svg";